import React from 'react';
import { get } from 'lodash';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/prescriptions-list';

export const memberDetailsPrescriptionsEntityWidgetSuccess = ( props ) => {
    const liveListEnabled = get( props.componentData, 'data.state.liveListEnabled', false )
        && Boolean( get( props.componentData, 'elements.urls.fetchLivePrescriptionsList', null ) );

    return (
        <div className='ui-member-details-prescriptions-entity-widget'>
            {/* The live-list action replaces the separate status check when available. */}
            { ! liveListEnabled && <div className='ui-member-details-prescriptions-entity-widget__header__live-status' aria-live='polite' aria-atomic='true'>
                <button
                    className={ `ui-member-details-prescriptions-entity-widget__header__live-status__button${ props.isCheckingLiveStatus ? ' ui-member-details-prescriptions-entity-widget__header__live-status__button--checking' : '' }` }
                    onClick={ props.onCheckLiveStatus }
                    disabled={ props.isCheckingLiveStatus }
                >
                    { props.isCheckingLiveStatus ? 'Checking…' : 'Check current status' }
                </button>
                { props.liveStatusAsOf && ! props.liveStatusError && (
                    <span className='ui-member-details-prescriptions-entity-widget__header__live-status__timestamp'>
                        { `Live as of ${ new Date( props.liveStatusAsOf ).toLocaleString() }` }
                    </span>
                ) }
                { props.liveStatusError === 'FETCH_FAILED' && (
                    <span className='ui-member-details-prescriptions-entity-widget__header__live-status__error'>
                        Unable to fetch live status &mdash; try again
                    </span>
                ) }
                { props.liveStatusError === 'STATUS_UNAVAILABLE' && (
                    <span className='ui-member-details-prescriptions-entity-widget__header__live-status__error'>
                        Status unavailable
                    </span>
                ) }
            </div> }
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                onActionClick={ props.onActionClick }
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                selectedRows = { props.selectedRxId }
                componentData={props.componentData}
                flow={'prescriptions'}
                liveListEnabled={ liveListEnabled }
                compactLiveListCopy
                liveListUrl={ get( props.componentData, 'elements.urls.fetchLivePrescriptionsList', null ) }
                // updateTableOnChange={ true }
                onSelectionCallBack={ props.onUpdateSelectionValues }
            />
        </div>
    );
};

// set display name
memberDetailsPrescriptionsEntityWidgetSuccess.displayName = 'memberDetailsPrescriptionsEntityWidgetSuccess';

// set default props
memberDetailsPrescriptionsEntityWidgetSuccess.defaultProps = {};

// prop types
memberDetailsPrescriptionsEntityWidgetSuccess.propTypes = {};

export const memberDetailsPrescriptionsEntityWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-prescriptions-entity-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-prescriptions-entity-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsPrescriptionsEntityWidgetPreloader.displayName = 'memberDetailsClaimsEntityWidgetPreloader';

// set default props
memberDetailsPrescriptionsEntityWidgetPreloader.defaultProps = {};

// prop types
memberDetailsPrescriptionsEntityWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsPrescriptionsEntityWidget as MemberDetailsPrescriptionsEntityWidget } from 'ui/views/widgets/memberDetailsPrescriptionsEntityWidget';
 *
 * // render
 * <MemberDetailsPrescriptionsEntityWidget propName='propValue'/>
 */
export const memberDetailsPrescriptionsEntityWidget = withNetworkState( memberDetailsPrescriptionsEntityWidgetPreloader, memberDetailsPrescriptionsEntityWidgetSuccess );
